import RequestState from '../../../types/RequestState';

/**
 *
 * @param {Object} props
 * @param {ManufacturerStore} props.manufacturerStore
 */
const useFetchData = ({ manufacturerStore }) => {
  if (
    !manufacturerStore.loadedWithContent &&
    manufacturerStore.state === RequestState.NONE
  ) {
    /* Use this as the common load function for all manufacturer locations */
    manufacturerStore.loadManufacturers({ excludeContent: true });
  }
};

export default useFetchData;
